import * as z from "zod/v4";

export const COMPLETABLE_PRODUCT_IDS = [
  "chargebacks",
  "contextual",
  "order-editing",
  "recover",
  "returns",
  "shipping-fulfillment",
] as const;
export type CompletableProductId = (typeof COMPLETABLE_PRODUCT_IDS)[number];

export const completeOnboarding = {
  name: "completeOnboarding" as const,
  input: z.object({ productId: z.enum(COMPLETABLE_PRODUCT_IDS) }),
  output: z.object({ ok: z.boolean() }),
};
